import {
  FETCH_SUBCONTRACTORS,
  FETCH_SUBCONTRACTOR_BY_EIK
} from "@/modules/subcontractors/store/subcontractor.module";

export const subcontractorExpenseAiMixin = {
  data() {
    return {
      subcontractors: []
    };
  },
  methods: {
    async loadSubcontractorDependencies() {
      await this.loadSubcontractors();
    },

    async loadSubcontractors() {
      try {
        const data = await this.$store.dispatch(
          FETCH_SUBCONTRACTORS,
          this.$url.transformParams({
            onlySelectValues: true,
            selectValueKey: "companyName",
            onlyWork: true
          })
        );
        this.subcontractors = data.data.items || data.data || [];
      } catch (error) {
        console.error("Error loading subcontractors:", error);
      }
    },

    async autoMatchSubcontractor(form) {
      if (!this.aiInvoiceData) return;

      const supplierVat = this.aiInvoiceData.supplierVat;
      const supplierName = this.aiInvoiceData.supplierName;

      // Try matching by VAT/Bulstat first
      if (supplierVat) {
        const matched = await this.fetchSubcontractorByEik(supplierVat);

        if (matched) {
          form.subcontractorId = matched.id;

          this.$notify({
            group: "notify",
            type: "success",
            text:
              this.$t("LABELS.SUBCONTRACTOR_AUTO_MATCHED_BY_VAT", {
                name: matched.companyName || matched.name,
                vat: supplierVat
              }) ||
              `Subcontractor auto-matched by VAT: ${matched.companyName ||
                matched.name} (${supplierVat})`
          });
          return;
        }
      }

      // Try matching by name if VAT match failed
      if (supplierName && this.subcontractors.length > 0) {
        const matched = this.autoMatchByName(
          this.subcontractors,
          supplierName,
          "companyName"
        );

        if (matched) {
          form.subcontractorId = matched.id;

          this.$notify({
            group: "notify",
            type: "info",
            text:
              this.$t("LABELS.SUBCONTRACTOR_AUTO_MATCHED_BY_NAME", {
                name: matched.companyName
              }) || `Subcontractor auto-matched by name: ${matched.companyName}`
          });
        }
      }
    },

    async fetchSubcontractorByEik(eik) {
      if (!eik) return null;

      try {
        const response = await this.$store.dispatch(
          FETCH_SUBCONTRACTOR_BY_EIK,
          eik
        );
        return response.data || response;
      } catch (error) {
        console.error("Error fetching subcontractor by eik:", error);
        return null;
      }
    }
  }
};
